import { connect } from 'react-redux';
import { RoleNames } from '@smorder/logic';
import FilterWrapper from './filter-wrapper';

const mapStateToProps = state => ({
  isReportsAdvanced: state.authentication && state.authentication.roles && state.authentication.roles.includes(RoleNames.ReportsAdvanced),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FilterWrapper);
